import state from "./activity-center-state";
import mutations from "./activity-center-mutations";
import actions from "./activity-center-actions";
import getters from "./activity-center-getters";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;